/**
 * Given the Madgex snippet, we insert it into the page,
 * then manually recreate its `<script>`, in order to execute it.
 * See https://stackoverflow.com/a/7054216/2917822.
 */
 export default function placeMadgexSnippet(snippet: string, madgexDiv: HTMLDivElement) {
  madgexDiv.innerHTML = snippet; // Attach the snippet provided by Madgex

  const scriptEl = madgexDiv.querySelector('script');
  if (scriptEl && scriptEl.src) {
      scriptEl.parentElement?.removeChild(scriptEl);
      const createdScriptEl = document.createElement('script');
      madgexDiv.appendChild(createdScriptEl);
      createdScriptEl.src = scriptEl.src;
  }
}
